import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { navigationService } from "etl/services";

export const WithNavigation = ({ children }: { children: React.ReactNode }) => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        navigationService.init(navigate, location);
    }, [navigate, location]);

    return (
        <>{children}</>
    );
};
